var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = __default(require("../../../../../util/handlebarsHelpers/shape.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"checkmark",{"name":"shape","hash":{},"data":data,"loc":{"start":{"line":2,"column":34},"end":{"line":2,"column":57}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-tooltip "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Styles") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
    + "\">\n    "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"studentGradingMode") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":2,"column":68}}})) != null ? stack1 : "")
    + "\n    <span data-empty-label=\""
    + alias2(__default(require("../../../../../util/handlebarsHelpers/__.js")).call(alias3,"Empty answer",{"name":"__","hash":{},"data":data,"loc":{"start":{"line":3,"column":28},"end":{"line":3,"column":49}}}))
    + "\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"correct") : depth0), depth0))
    + "</span>\n</div>\n";
},"useData":true});